"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signal = void 0;
/**
 * Describes a BPMN Signal element.
 */
class Signal {
}
exports.Signal = Signal;
//# sourceMappingURL=Signal.js.map